import * as React from 'react';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import { Heading, Rectangle, StyledCard, StyledCardContent } from './styles';
import { COLORS } from '../../../../values/colors';
import {Paragraph} from '../../../../lib/Font/styles';
import { middleSmallBottomAnimationProps,  quickSmallBottomAnimationProps } from '../../../functionallity/animationProps';

export interface CommiteeProfileCardProps {
    name: string;
    job: string;
} 

const CommiteeProfileCard: React.FC<CommiteeProfileCardProps> = (props) => {
    return (
        <StyledCard style={{borderRadius: 25}}>
            <CardActionArea>
                <CardMedia
                    component="img"
                    height="300"
                    image={require('../../../../assets/images/Elders/portrait_placeholder.jpg')}
                    alt="Committee Portrait"
                />
                <StyledCardContent>
                    <Heading {...quickSmallBottomAnimationProps}>
                        {props.name}
                    </Heading>
                    <Rectangle {... quickSmallBottomAnimationProps}/>
                    <Paragraph {...middleSmallBottomAnimationProps} color={COLORS.textSecondary}>
                        {props.job}
                    </Paragraph>
                </StyledCardContent>
            </CardActionArea>
        </StyledCard>
    );
}

export default CommiteeProfileCard;
